<div class="h-[55vh] d-flex flex-column">
    @if (!isNewEntity()) {
        <div class="px-3">
            @if (scope() === 'user') {
                <div class="mb-3">
                    <h5 class="fw-semibold">Select Branch</h5>
                    <kendo-dropdownlist
                        [data]="branches()"
                        textField="name"
                        valueField="id"
                        [valuePrimitive]="false"
                        [value]="selectedBranch"
                        (valueChange)="onBranchChange($event)"
                        [defaultItem]="{name: '-- Select a Branch --', id: null}"
                        class="w-50"
                    ></kendo-dropdownlist>
                </div>
                @if (selectedBranch?.id) {
                    <hr class="my-4">
                }
            }

            @if (scope() !== 'tenant' && store.inheritedTenantProviders().length > 0) {
                <div class="mb-5">
                    <h5 class="fw-semibold">Inherited from Tenant</h5>
                    <table class="table table-sm table-bordered">
                        <thead>
                        <tr>
                            <th>API ID</th>
                            <th>API Key</th>
                            <th>Type</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            @for (provider of store.inheritedTenantProviders(); track provider.id) {
                                <tr class="table-light">
                                    <td class="text-muted">{{ provider.apiId }}</td>
                                    <td class="text-muted">{{ provider.apiKey }}</td>
                                    <td class="text-muted">{{ provider.type }}</td>
                                    <td>
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary"
                                            (click)="overrideHandler(provider)"
                                            [disabled]="store.loading()"
                                        >
                                            Override
                                        </button>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }

            @if (scope() === 'user' && store.inheritedBranchProviders().length > 0) {
                <div class="mb-5">
                    <h5 class="fw-semibold">Inherited from Branch</h5>
                    <table class="table table-sm table-bordered">
                        <thead>
                        <tr>
                            <th>API ID</th>
                            <th>API Key</th>
                            <th>Type</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            @for (provider of store.inheritedBranchProviders(); track provider.id) {
                                <tr class="table-light">
                                    <td class="text-muted">{{ provider.apiId }}</td>
                                    <td class="text-muted">{{ provider.apiKey }}</td>
                                    <td class="text-muted">{{ provider.type }}</td>
                                    <td>
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-primary"
                                            (click)="overrideHandler(provider)"
                                            [disabled]="store.loading()"
                                        >
                                            Override
                                        </button>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }

            @if (scope() !== 'user' || selectedBranch?.id) {
                <div class="d-flex align-items-center mb-2">
                    <h5 class="fw-semibold mb-0 me-2">{{ scopeTitle }}</h5>
                    <button type="button" class="btn btn-sm text-primary" (click)="addProvider()">
                        <i class="bi bi-plus-circle"></i>
                        Add
                    </button>
                </div>
            }
        </div>

        @if (scope() !== 'user' || selectedBranch?.id) {
            <div class="flex-grow-1 px-3">
                <kendo-grid
                    #grid
                    [data]="providers"
                    [loading]="store.loading()"
                    [navigable]="true"
                    (edit)="editHandler($event)"
                    (remove)="removeHandler($event)"
                    (save)="saveHandler($event)"
                    (cancel)="cancelHandler($event)"
                >
                    <kendo-grid-column field="value.apiId" title="API ID">
                        @if (scope() !== 'tenant') {
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                @if (getParentProvider(dataItem.value.type); as parent) {
                                    <span [class]="'badge ' + getBadgeClass(parent)">
                                        Overrides: {{ parent.apiId }}
                                    </span>
                                    <br>
                                }
                                <span>{{ dataItem.value.apiId }}</span>
                            </ng-template>
                        }
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                            <input
                                kendoGridFocusable
                                class="form-control form-control-sm"
                                [formControl]="dataItem.get('apiId')"
                                placeholder="API ID"
                            />
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="value.apiKey" title="API Key">
                        @if (scope() !== 'tenant') {
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                @if (getParentProvider(dataItem.value.type); as parent) {
                                    <span [class]="'badge ' + getBadgeClass(parent)">
                                        Overrides: {{ parent.apiKey }}
                                    </span>
                                    <br>
                                }
                                <span>{{ dataItem.value.apiKey }}</span>
                            </ng-template>
                        }
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                            <input
                                kendoGridFocusable
                                class="form-control form-control-sm"
                                [formControl]="dataItem.get('apiKey')"
                                placeholder="API Key"
                            />
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="value.type" title="Type*">
                        @if (scope() !== 'tenant') {
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                @if (getParentProvider(dataItem.value.type); as parent) {
                                    <span [class]="'badge ' + getBadgeClass(parent)">
                                        Overrides {{ getParentScope(parent) }}
                                    </span>
                                    <br>
                                }
                                <span>{{ dataItem.value.type }}</span>
                            </ng-template>
                        }
                        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                            <select class="form-select form-select-sm" [formControl]="dataItem.get('type')">
                                <option value="" disabled>Select Type</option>
                                @for (type of externalProviderTypes; track type) {
                                    <option [value]="type">{{ type }}</option>
                                }
                            </select>
                            <span class="text-sm text-danger">
                                {{ getErrorMessages(dataItem.controls.type) }}
                            </span>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-command-column title="Actions" [width]="200">
                        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                            <button kendoGridEditCommand type="button" class="btn btn-sm btn-outline-primary ms-2 me-1">
                                <i class="bi bi-pencil"></i>
                            </button>
                            <button kendoGridRemoveCommand type="button" class="btn btn-sm btn-outline-danger me-1">
                                <i class="bi bi-trash"></i>
                            </button>
                            <button kendoGridSaveCommand type="button" class="btn btn-sm btn-outline-success me-1">
                                <i class="bi bi-check"></i>
                            </button>
                            <button kendoGridCancelCommand type="button" class="btn btn-sm btn-outline-secondary me-1">
                                <i class="bi bi-x"></i>
                            </button>
                            @if (!dataItem.pristine && !dataItem.valid) {
                                <i class="bi bi-exclamation-triangle text-danger float-end" [title]="getInvalidFields(dataItem)"></i>
                            }
                        </ng-template>
                    </kendo-grid-command-column>
                </kendo-grid>
            </div>
        }
    } @else {
        <div class="px-3 border bg-body flex-grow-1">
            <p class="form-text">No external providers available. Please save first to add external providers.</p>
        </div>
    }
</div>
